import { isApplicationNonProd } from 'Utilities/helpers';

import { DealerRatingAttributes } from './DealerRatingsExperiment.types';
import dealerRatingsCohort from './DealerRatingsExperimentCohort.json';

type GetBidPositionParams = {
  closingBidValue?: number | null;
  prepCosts?: number | null;
  priceHigh?: number | null;
  sellerWillAcceptPrice?: number | null;
};

export const getIsDealerInCohort = (dealerId?: number): boolean => {
  const cohortToUse = isApplicationNonProd ? 'stage' : 'production';
  return dealerId !== undefined && dealerRatingsCohort[cohortToUse].some((dealer) => dealer.dealerId === dealerId);
};

export const getDealerRatingAttributes = (dealerId?: number): DealerRatingAttributes => {
  const cohortToUse = isApplicationNonProd ? 'stage' : 'production';
  const dealerData = dealerRatingsCohort[cohortToUse].find((dealer) => dealer.dealerId === dealerId);
  return {
    averageRating: dealerData?.averageRating ?? 0,
    reviewCount: dealerData?.reviewCount ?? 0,
  };
};

export const getIsReservePriceMet = ({
  closingBidValue,
  prepCosts,
  priceHigh,
  sellerWillAcceptPrice,
}: GetBidPositionParams): boolean => {
  if (!priceHigh || !closingBidValue) {
    return false;
  }

  const reservePrice = sellerWillAcceptPrice ?? priceHigh - (prepCosts ?? 0);

  return closingBidValue >= reservePrice;
};
